export const normalizeAddressName = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
export const parseProfileAddress = address => {
    const lines = String(address || '').split('\n');
    const details = {};
    const street = lines.filter(line => {
        const match = line.match(/^(Village|Taluk|District): (.+)$/);
        if (!match) return true;
        details[match[1]] = match[2];
        return false;
    }).join('\n');
    return {street, village: details.Village || '', taluk: details.Taluk || '', district: details.District || ''};
};
export const buildProfileAddress = (street, village, taluk, district) => [String(street || '').trim(), village && 'Village: ' + village, taluk && 'Taluk: ' + taluk, district && 'District: ' + district].filter(Boolean).join('\n');
export const parsePinOffices = data => {
    const result = Array.isArray(data) ? data[0] : data;
    if (result?.Status !== 'Success' || !Array.isArray(result.PostOffice)) return [];
    return result.PostOffice.filter(office => office.Name && office.State);
};
